import { logger } from "@mgdx-libs/logger";
import { IdTokenResult, User } from "firebase/auth";

export class FirebaseUserRoleNoneError extends Error {}

// IndexedDB AbortError (iOS WKWebView サスペンド時など) を表す専用エラークラス。
// 呼び出し元でこのエラーを判別し、永続エラー画面ではなくリカバリー可能な処理に振り分けるために使用する。
export class FirebaseIndexedDBAbortError extends Error {
  constructor(
    message: string,
    public readonly originalError: unknown
  ) {
    super(message);
    this.name = "FirebaseIndexedDBAbortError";
  }
}

export const getAuthedFirebaseUserToken = async (firebaseUser: User): Promise<IdTokenResult> => {
  logger.debug("firebase.User: %o", firebaseUser);

  const result = await firebaseUser.getIdTokenResult().catch((error: unknown) => {
    // iOS WKWebView サスペンド時に発生する IndexedDB AbortError を専用エラーとして再スロー
    if (
      (error instanceof Error && error.name === "AbortError") ||
      (error as { code?: string })?.code === "app/idb-get" ||
      (error as { code?: string })?.code === "app/idb-set"
    ) {
      logger.debug("getIdTokenResult: IndexedDB AbortError", error);
      throw new FirebaseIndexedDBAbortError("getIdTokenResult: IndexedDB AbortError", error);
    }
    throw error;
  });

  if (result.claims.role === undefined || result.claims.role === "none") {
    throw new FirebaseUserRoleNoneError("firebase.User: role is none");
  } else if (result.claims.role !== "patient") {
    throw new Error(`firebase.User: different role, ${result.claims.role}`);
  }

  logger.debug("getIdTokenResult: %o", result);
  return result;
};
